import { IConfig } from "Config";
var config:IConfig = {
    linkSupport: "https://ehoadon.online/hoi-dap"
};

export default config;